import { useSelector } from "react-redux";

import classes from "../../maintainers.module.scss";

const IrrigationTableBodyDetail = ({ item, _permissions }) => {
	const { customer } = useSelector((state) => state.auth.user);

	if (!item.active) {
		return null;
	}

	return (
		<tr>
			<td colSpan={7} style={{ padding: "0.02rem 0.75rem 0.75rem 0.75rem" }}>
				<table className="table table-striped">
					<thead>
						<tr className="text-center">
							<th className={classes.th_detail}>{customer.use_sectors ? "Sector" : "Centro de Costo"}</th>
							<th className={classes.th_detail}>Superficie (Ha)</th>
						</tr>
					</thead>
					<tbody>
						{item &&
							item.details &&
							item.details.map((businessCenter, index) => {
								return (
									<tr className={`${classes.table_tr}`} key={index}>
										<td className={classes.table_td}>
											<div className={`${classes.table_div} ${classes.long_text} ${classes.center}`}>{businessCenter.name}</div>
										</td>
										<td className={classes.table_td}>
											<div className={`${classes.table_div} ${classes.long_text} ${classes.center}`}>{businessCenter.ha ?? 0}</div>
										</td>
									</tr>
								);
							})}
					</tbody>
				</table>
			</td>
		</tr>
	);
};

export default IrrigationTableBodyDetail;
